import { render, staticRenderFns } from "./tp1Grid.vue?vue&type=template&id=96194510"
import script from "./tp1Grid.vue?vue&type=script&lang=js"
export * from "./tp1Grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports